<template>
    <div class="kibana-container">
        <iframe
            id="myFrame"
            sandbox="allow-scripts allow-same-origin"
            :src="kibanaLocation"
            :height="dimensions.height-60"
            :width="dimensions.width">
        </iframe>
    </div>
</template>

<script type="text/babel">
export default {
    name: 'Kibana',
    data () {
        return {};
    },
    props: {
        dimensions: {
            type: Object
        },
        kibanaLocation: {
          type: String
        }
    }
};

</script>

<style lang="scss">
  iframe{
    border: #ecf0f1;
  }
  .kibana-container{
    position: absolute;
    top: 50px;
  }
</style>
